import type { DeleteActionUpdatesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteActionUpdatesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteActionUpdate = createMutationHook({
  name: 'deleteActionUpdates',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.action.updates.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ ids }),
  invalidate: (trpc) => [
    trpc.frontend.action.updates.getActionUpdatesByParentActionId.queryKey(),
    trpc.frontend.action.updates.getActionUpdateById.queryKey(),
    // COI-889: the Actions register's latest-update and update-count columns
    // read `actionUpdateSummary`.
    trpc.frontend.action.register.queryKey(),
  ],
  mapResponse: (_result, ids: string[]): DeleteActionUpdatesMutation => ({
    delete_file: {
      __typename: 'file_mutation_response',
      affected_rows: 0,
    },
    delete_relation_file: {
      __typename: 'relation_file_mutation_response',
      affected_rows: 0,
    },
    delete_action_update: {
      __typename: 'action_update_mutation_response',
      affected_rows: ids.length,
    },
  }),
  graphqlDocument: DeleteActionUpdatesDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: ['action_update'],
});
